import styled from 'styled-components';

export const StyledText = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: rgb(255, 255, 255);
`;
